import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface CardContainerProps {
    isDragging: boolean;
    isSelected: boolean;
    isSelecting: boolean;
    isSelectionFull: boolean;
    isOver: boolean;
    canDrop: boolean;
    isDraggable: boolean;
    isDragActive: boolean;
    isStitchGreyedOut: boolean;
}

export const CardContainer = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'isDragging' &&
        prop !== 'isSelected' &&
        prop !== 'isSelecting' &&
        prop !== 'isSelectionFull' &&
        prop !== 'isOver' &&
        prop !== 'canDrop' &&
        prop !== 'isDraggable' &&
        prop !== 'isDragActive' &&
        prop !== 'isStitchGreyedOut'
})<CardContainerProps>(
    ({
        isDragging,
        isSelected,
        isSelecting,
        isSelectionFull,
        isOver,
        canDrop,
        isDraggable,
        isDragActive,
        isStitchGreyedOut,
        theme
    }) => {
        function getBorder() {
            if (isSelected) {
                return '2px solid #3D9970';
            }
            if (isDragging) {
                return '2px dashed #1976d2';
            }
            if (isOver && canDrop) {
                return '2px dashed #3b873e';
            }
            if (isDragActive && isDraggable && !isDragging) {
                return '2px dashed rgba(25, 118, 210, 0.35)';
            }
            return '2px solid transparent';
        }

        function getBoxShadow() {
            if (isDragging) {
                return 'none';
            }
            if (isOver && canDrop) {
                return '0 4px 12px rgba(59, 135, 62, 0.25)';
            }
            return '0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08)';
        }

        function getOpacity() {
            if (isStitchGreyedOut) {
                return 0.5;
            }
            if (isDragging) {
                return 0.45;
            }
            if (isSelecting && isSelectionFull && !isSelected) {
                return 0.5;
            }
            return 1;
        }

        return {
            width: 260,
            [theme.breakpoints.down('sm')]: {
                width: '100%'
            },
            backgroundColor: isDragging ? '#f5f5f5' : isSelected ? '#3D9970' : '#fff',
            borderRadius: '4px',
            border: getBorder(),
            boxShadow: getBoxShadow(),
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            cursor: isDragging
                ? 'grabbing'
                : isStitchGreyedOut
                ? 'default'
                : isSelecting && isSelectionFull && !isSelected
                ? 'not-allowed'
                : 'default',
            opacity: getOpacity(),
            transform: isOver && canDrop && !isDragging ? 'scale(1.02)' : 'none',
            transition:
                'opacity 0.2s ease, transform 0.15s ease, box-shadow 0.15s ease, border 0.15s ease, background-color 0.15s ease',
            position: 'relative',
            '&:hover .drag-handle': {
                opacity: 1
            }
        };
    }
);
